import React, { useEffect, useState } from "react";


import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import CustomTable from "./../../Components/CustomTable";

import "./style.css";

import Header from "../../Components/Header";
import { useGetBookingQuery } from "../../Redux/Apis/Booking";
import { useUpdateUserMutation } from "../../Redux/Apis/User";
import { dateFormatter } from "../../Utils";
import { useNavigate } from "react-router";
import usePagination from "../../Hooks/usePagination";
import useSearch from "../../Hooks/useSearch";

const sortValues = [
  {
    text: "Name",
    value: "fullName",
  },
  {
    text: "Email",
    value: "email",
  }
];

const perPageValues = [
  {
    text: "8",
    value: 8,
  },
  {
    text: "15",
    value: 15,
  },
  {
    text: "30",
    value: 30,
  }
];


const maleHeaders = [
  {
    key: "id",
    title: "Id No",
  },
  {
    key: "start_date",
    title: "Start Date",
  },
  {
    key: "end_date",
    title: "End Date",
  },
  {
    key: "contract_form",
    title: "Contract Form",
  },
  {
    key: "contract_to",
    title: "Contract To",
  },
  {
    key: "status",
    title: "Status",
  },
  {
    key: "services",
    title: "Services",
  },
  {
    key: "price",
    title: "Price",
  },
  {
    key: "promo",
    title: "Promo",
  },
  {
    key: "discount",
    title: "Discount",
  },
  {
    key: "actions",
    title: "",
  },
];

const ContractMessages = () => {

  const navigate = useNavigate()
  const [changeUserStatus, { isLoading: isUpdating }] = useUpdateUserMutation();

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
  const [inputValue, setInputValue] = useState('');
  const [selectedUserId, setSelectedUserId] = useState();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [sortBy, setSortBy] = useState();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [filters, setFilters] = useState()

  const [search, debouncedSearch, onSearch] = useSearch()
  const { page, perPage, onNext, onPrevious } = usePagination()
  const { data, isFetching: isLoading, refetch } = useGetBookingQuery({
    page,
    rowsPerPage: perPage,
    search: debouncedSearch,
    sortBy,
    from,
    to,
    ...(filters ? filters : {})
  }, { refetchOnReconnect: true });

  const onChangeFilters = (key, value) => {
    let temp = { ...filters }
    temp[key] = value
    setFilters(temp)
  }

  const FILTER_OPTIONS = [
    {
      label: "Status",
      value: filters?.status,
      setValue: (val) => onChangeFilters("status", val),
      options: [{ label: "All", value: "" }, { label: "Pending", value: "pending" }, { label: "Canceled", value: "canceled" }, { label: "Completed", value: "completed" }, { label: "Accepted", value: "accepted" }, { label: "Suspended", value: "suspended" }]
    }
  ]

  const toggleFilter = () => setIsFilterOpen(!isFilterOpen)

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const inactiveMale = async () => {
    await changeUserStatus({ id: selectedUserId, payload: { active: false } })
    refetch()
    setSelectedUserId()
    setShowModal(false)
    setShowModal2(true)
  }

  const activeMale = async () => {
    await changeUserStatus({ id: selectedUserId, payload: { active: true } })
    refetch()
    setSelectedUserId()
    setShowModal3(false)
    setShowModal4(true)
  }

  const handleChange = (e) => {
    setInputValue(e.target.value);
  }

  useEffect(() => {
    document.title = 'Landing List | Contract Messages';
  }, []);

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header
                  title="Contract Messages"
                  search={search}
                  onSearch={onSearch}
                  options={FILTER_OPTIONS}
                />
                <div className="row mb-3">
                  {
                    isLoading ? <Loader /> :
                      <div className="col-12">
                        <CustomTable
                          headers={maleHeaders}
                          isFilterOpen={isFilterOpen}
                          dateFilter={false}
                          filterSort={false}
                          perPage={true}
                          filterSortValues={sortValues}
                          perPageValues={perPageValues}
                          filterSortValue={sortBy}
                          setFilterSortValue={setSortBy}
                          filterFrom={from}
                          setFilterFrom={setFrom}
                          filterTo={to}
                          setFilterTo={setTo}
                          itemsPerPage={itemsPerPage}
                          setItemsPerPage={setItemsPerPage}
                          length={data?.data?.length}
                          page={page}
                          rowsPerPage={perPage}
                          onNext={onNext}
                          onPrevious={onPrevious}
                          total={data?.total}
                        >
                          <tbody>
                            {data?.data?.map((item, index) => (
                              <tr key={item._id}>
                                {/* <td><input type="checkbox" /></td> */}
                                <td>{(index + 1) + ((page - 1) * perPage)}</td>
                                <td>{dateFormatter(item.start_date)}</td>
                                <td>{dateFormatter(item.end_date ?? item?.start_date)}</td>
                                <td className="text-capitalize">{item?.from_user?.first_name} {item?.from_user?.last_name}</td>
                                <td className="text-capitalize">{item?.to_user?.first_name} {item?.to_user?.last_name}</td>
                                <td className={`text-capitalize ${(item.status === "completed" || item.status === "paid") ? "text-success" : item.status === "pending" ? "text-warning" : (item.status === "declined" || item.status === "canceled") ? "text-danger" : item.status === "accepted" ? "text-primary" : "text-dark"}`}>{item.status}</td>
                                <td>{item?.facilitation?.service?.title}</td>
                                <td>{(item.total_amount).toFixed(2)} SAR</td>
                                <td>{item.payment?.promo?.code || "-"}</td>
                                <td>{((item.total_amount * item.payment?.promo?.percentage) / 100) || "0"} SAR</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <CustomButton variant="primaryButton" text="View Messages" className="mx-1" onClick={() => navigate(`/contract-messages/${item?._id}`)} />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </CustomTable>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <CustomModal loading={isUpdating} show={showModal} close={() => { setShowModal(false) }} action={inactiveMale} heading='Are you sure you want to mark this user as inactive?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Inactive' />

          <CustomModal loading={isUpdating} show={showModal3} close={() => { setShowModal3(false) }} action={activeMale} heading='Are you sure you want to mark this user as Active?' />
          <CustomModal show={showModal4} close={() => { setShowModal4(false) }} success heading='Marked as Active' />
        </div>
      </DashboardLayout>
    </>
  );
};

export default ContractMessages
